import dayjs from 'dayjs'
import customParseFormat from 'dayjs/plugin/customParseFormat'

dayjs.extend(customParseFormat)

const TIME_FORMAT = 'hh:mm A'
const TIME_FORMATS = [
  'hh:mm A',
  'h:mm A',
  'HH:mm',
  'H:mm',
  'hh:mm:ss A',
  'h:mm:ss A',
]

const parseTime = (time) => {
  if (!time) return dayjs(null)

  if (time instanceof Date || dayjs.isDayjs(time)) {
    return dayjs(time)
  }

  const value = String(time).trim()
  for (const format of TIME_FORMATS) {
    const parsed = dayjs(value, format, true)
    if (parsed.isValid()) return parsed
  }

  const parsed = dayjs(value)
  return parsed.isValid() ? parsed : dayjs(null)
}

export const getGeneralDate = (date) => {
  const dateFormat = 'D MMM, YY' // 1 May, 97
  return dayjs(date).format(dateFormat)
}

export function getFullFormat(time) {
  return parseTime(time).format('HH:mm')
}

export function getGenTime(time) {
  return parseTime(time).format(TIME_FORMAT)
}

export function getTimeDifference(start, end) {
  return parseTime(end).diff(parseTime(start), 'hour')
}

export function getTimeDifferenceInMins(start, end) {
  return parseTime(end).diff(parseTime(start), 'minute')
}

export function checkIsAfter(start, end) {
  return parseTime(end).isAfter(parseTime(start))
}

export function checkIsToday(date) {
  return dayjs(date).isSame(dayjs(), 'day')
}

export function dateIsAfter(start, end) {
  return dayjs(start).isAfter(dayjs(end), 'day')
}

export function dateIsSame(start, end) {
  return dayjs(start).isSame(dayjs(end), 'day')
}
